import React from 'react';
import * as FontAwesome from 'react-icons/lib/fa';

function StatusCell({ statusString }) {
  const isActive = statusString === 'Active';
  const cls = isActive ? 'pm-status pm-status--active' : 'pm-status pm-status--inactive';
  return (
    <span className={cls}>
      <span className="pm-status-dot" />
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );
}

const PAGE_SIZE = 10;

export default class PeriodicalTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 1 };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ currentPage: 1 });
    }
  }

  render() {
    const data = this.props.data || [];
    const { currentPage } = this.state;
    const totalPages = Math.ceil(data.length / PAGE_SIZE) || 1;
    const start = (currentPage - 1) * PAGE_SIZE;
    const pagedData = data.slice(start, start + PAGE_SIZE);

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="pm-table-scroll">
            <table className="periodical-master-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Periodical Name</th>
                  <th>Default Frequency</th>
                  <th>Default Count</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {pagedData.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: 'center', color: '#aaa', padding: '32px' }}>
                      No data available
                    </td>
                  </tr>
                ) : (
                  pagedData.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td>{row.default_frequency_name}</td>
                      <td>{row.default_frequency_count}</td>
                      <td><StatusCell statusString={row.statusString} /></td>
                      <td>
                        <button
                          className="pm-action-btn pm-action-btn--edit"
                          title="Edit"
                          onClick={() => this.props.edit_click(row.id)}
                        ><FontAwesome.FaEdit /></button>
                        <button
                          className="pm-action-btn pm-action-btn--delete"
                          title="Delete"
                          onClick={() => this.props.delete_toggle(row.id)}
                        ><FontAwesome.FaTrash /></button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="pm-pagination">
                <button
                  className="pm-page-btn"
                  disabled={currentPage === 1}
                  onClick={() => this.setState({ currentPage: currentPage - 1 })}
                >&#8249; Prev</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <button
                    key={page}
                    className={`pm-page-btn${page === currentPage ? ' active' : ''}`}
                    onClick={() => this.setState({ currentPage: page })}
                  >{page}</button>
                ))}
                <button
                  className="pm-page-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => this.setState({ currentPage: currentPage + 1 })}
                >Next &#8250;</button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Periodicals/periodical_table.js